import React, { Component } from 'react';
import TableParent from '../commonComponents/TableParent';
import CallAPI from '../commonComponents/AxiosHelper';
import Form from '../commonComponents/Form.v2';
import ModalComponent from '../commonComponents/ModalComponent';
import ErrorComponent from '../commonComponents/ErrorComponent';
import sanitizeHtml from 'sanitize-html';
import Pagination from '../../../src/components/PinboardComponents/Pagination';

var toAddNewUserData = null
class UserComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: null,
            updatedUsers: null,
            userStatus: {
                0: { "name": "Active", "value": 0 },
                1: { "name": "Suspended", "value": 1 },
                2: { "name": "Deleted", "value": 2 },
                // "No Access": { "name": "No Access", "value": 0 },
                // "Admin": { "name": "Admin", "value": 1 },
                // "Read Only": { "name": "Read Only", "value": 3 },
            },
            activatedMail: {
                0: { "name": "Inactive", "value": 0 },
                1: { "name": "Active", "value": 1 },
            },
            property: null,
            selecteduser: null,
            currentPage: 1,
            totalPages: null,
            searchValue:null,
        };

        this.formData = {
            "firstName": { "name": "firstName", "label": "First Name", "type": "text", "requiredFlag": true },
            "lastName": { "name": "lastName", "label": "Last Name", "type": "text", "requiredFlag": true },
            "email": { "name": "email", "label": "Email", "type": "email", "requiredFlag": true },
            "phoneNumber": { "name": "phone", "label": "Phone Number", "type": "text", "requiredFlag": true },
            "password": { "name": "password", "label": "Password", "type": "password", "requiredFlag": true, 'eyeIcon': true },
        }

        this.bulkFormData = {
            "userStatus": {
                "name": "userStatus", "label": "User Status", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "3" }, ...Object.values(this.state.userStatus)
                ]
            },
            "activatedMail": {
                "name": "activatedMail", "label": "Email Access", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "3" }, ...Object.values(this.state.activatedMail)
                ]
            }
        }

        this.importFormData = {
            "fileImport": {
                "name": "fileImport", "label": "File Import", "type": "file"
            }
        }

        this.buttons = {
            "addButton": [{
                "label": "Add User", "type": "normal", "display": true, "action": "add", 'modal_id': "#addContent"
            }],
            "dropdownConfig": [{
                "label": "More", "type": "dropdown", "display": true,
                "children": [
                    // {  "label": "File Format Download", "action": "file" },
                    { "label": "Export CSV", "action": "export" },
                    // { "label": "Import CSV", "action": "import" },
                ]
            }],
            "editButton": [{ "class": "", "label": "Edit", "type": "normal", "display": true, "action": "edit" }],
            "saveButton": [{
                "class": "", "label": "Save", "type": "normal", "display": false, "action": "save"
            }],
            "cancelButton": [{ "class": "", "label": "Cancel", "type": "normal", "display": false, "action": "cancel" }],
            "loadingButton": [{ "id": "loadingButton", "type": "loading", "display": false, "action": "load" }]
        }

        this.change_handle = this.change_handle.bind(this);
        this.saveHandle = this.saveHandle.bind(this);
        this.submitHandle = this.submitHandle.bind(this);
        this.restrictMenuOption = this.restrictMenuOption.bind(this);
        this.change_table_format = this.change_table_format.bind(this);
        this.handleDataUpdate = this.handleDataUpdate.bind(this);
        this.text_to_json = this.text_to_json.bind(this);
        this.fetchUserData = this.fetchUserData.bind(this);
        this.searchUser = this.searchUser.bind(this);
        this.handleUserAccess = this.handleUserAccess.bind(this);
        this.handleUserUpdate = this.handleUserUpdate.bind(this);
        this.userAccessTable = this.userAccessTable.bind(this);
        this.resetUserPassword = this.resetUserPassword.bind(this);
        // this.handleUsernameFormat = this.handleUsernameFormat.bind(this);
    }

    componentWillMount() {
        this.fetchUserData();
    }

    componentDidMount() {
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
    }

    componentDidUpdate(prevProps, nextState) {
        if (prevProps.datasetValue !== this.props.datasetValue) {
            let that = this;
            this.fetchUserData();
        }
    }
    

  

    searchUser(e, action = null) {
        let searchUser = e.target?.value
        let searchValue = document.getElementById('searchKeyword').value
        if (e && e?.key === 'Enter') {
            this.setState({ searchValue: searchUser })
            this.fetchUserData(null, 'search', searchUser)
        } else if (action == 'remove') {
            if (this.state.searchValue && searchValue != '' && searchValue != undefined) {
                this.fetchUserData(null, 'remove', '')
            }
            document.getElementById('searchKeyword').value = ''
        }
    }


    fetchUserData(page = null, action = null, searchValue,isReportRemoved=false) {
        let that = this;
        that.setState({ users: null });
        if(isReportRemoved==true){
                const { history, location } = this.props;
                history.replace(location.pathname, null);
       }
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            companyName: that.props.authData.companyName,
            page: action != null && searchValue ? 1 : page ? page : that.state.currentPage,
            // perPage: 15
            // toolId: this.props.datasetValue
        }
        if (action == 'search' && searchValue) {
            params['searchKeyword'] = searchValue
        }
        CallAPI('get', '/app/userConfig/getUsers', null, params, 0, function (response) {
            if (response?.status == false) {
                checkIfMaintenanceModeOn(response)
            }
            if (that.props.location.state?.data && action!='remove') {
                let userID = JSON.parse(that.props.location.state?.data.toUser)
                let filterUsers = response?.users.filter(val => userID.includes(val.userId));
                that.setState({ ...that.state, users: filterUsers, totalPages: response.totalPages, searchValue: searchValue })
            } else {
                that.setState({ ...that.state, users: response.users, totalPages: response.totalPages, searchValue: searchValue})
            }
            if (action != null && searchValue != '') {
                that.setState({ ...that.state, currentPage: 1 })
            }
        }, that.props.authData)
    }

    change_handle(data) {
        let user_obj = this.state.users;

        let final_value = data.value;
        if (data.colDef.field == "status") {
            if (final_value == 'Suspended') {
                user_obj[data.node.id]['isSuspended'] = "1";

            } else if (final_value == 'Deleted') {
                user_obj[data.node.id]['isDeleted'] = "1";
                user_obj[data.node.id]['isSuspended'] = "0";

            } else if (final_value == 'Active') {
                user_obj[data.node.id]['isSuspended'] = "0";
            }

            user_obj[data.node.id]['rockmetric_update'] = true;
            if (user_obj[data.node.id]['rockmetric_update_columns'] == undefined) {
                user_obj[data.node.id]['rockmetric_update_columns'] = []
            }

            if (final_value == 'Suspended' || final_value == 'Active') {
                user_obj[data.node.id]['rockmetric_update_columns'].push("isSuspended");
            }
            else if (final_value == 'Deleted') {
                user_obj[data.node.id]['rockmetric_update_columns'].push("isDeleted", "isSuspended");
            }
        }


        if (this.state[data.colDef.field]) {
            Object.values(this.state[data.colDef.field]).map(function (innerData) {
                if (innerData.name == data.value) {
                    final_value = innerData.value;
                }
            })
        }

        let field = data.colDef.field == "label" ? "value" : data.colDef.field;
        user_obj[data.node.id][field] = final_value;


        user_obj[data.node.id]['rockmetric_update'] = true;

        if (user_obj[data.node.id]['rockmetric_update_columns'] == undefined) {
            user_obj[data.node.id]['rockmetric_update_columns'] = [];
        }

        if (!user_obj[data.node.id]['rockmetric_update_columns'].includes(field)) {
            user_obj[data.node.id]['rockmetric_update_columns'].push(field);
        }
    }

    submitHandle(e) {
        let that = this;
        let toupdatedata = null;
        let data = this.state.users;
        function returnUpdatedValue(data) {
            if (data['rockmetric_update'] == true && data['rockmetric_new_entry'] !== true) {
                return data;
            }
        }

        if (data) {
            toupdatedata = data.filter(returnUpdatedValue);
        }

        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            companyName: this.props.authData.companyName
        }

        if (toupdatedata.length != 0) {
            isAdHocDataLoading(true)
            CallAPI('POST', '/app/userConfig/updateUserStatus', toupdatedata, params, 0, function (response) {
                if (response['status'] == true) {
                    isDataLoading(false)
                    alert("Successfully updated.");
                }
                else {
                    alert("Some error occured while updating");
                }
                // location.reload();
                that.fetchUserData();
            }, this.props.authData)
        }
        else {
            function returnNewUserValue(data) {
                if (data['rockmetric_update'] == true && data['rockmetric_new_entry'] == true) {
                    return data;
                }
            }
            if (data) {
                toAddNewUserData = data.filter(returnNewUserValue);
            }

            // let user = this.state.users;
            toAddNewUserData['siteId'] = localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                toAddNewUserData['emailVerify'] = 1;


            let url = '/app/userConfig/addUser';
            // user = encodePostBody(user)
            CallAPI('POST', url, toAddNewUserData, params, 0, function (response) {
                // if (response['status'] == false) {
                //   
                // } else if (response['false'] === 404) {
                //   alert("User with the same Name already Exists!");
                // }
                // else if (response['message']=='Created') {
                //   alert("Successfully Added.");
                // }
                if (response['status'] == false) {
                    alert(response['information']);
                } else {
                    toAddNewUserData.map(function (innerData) {
                        let responseJSON = JSON.parse(response[innerData.primaryEmail])
                        if (responseJSON['createStatus']) {
                            alert(`User: ${innerData.label} created successfully`)
                        } else {
                            alert(responseJSON.information)
                        }
                    })
                }
                //   location.reload();
                that.fetchUserData();
                toAddNewUserData = null
            }, this.props.authData)

        }
    }

    handleUserUpdate(postData) {
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            companyName: this.props.authData.companyName
        }
        // postData = encodePostBody(postData)
        CallAPI('POST', '/app/userConfig/updateUserStatus', postData, params, 0, function (response) {
            if (response['status'] == true) {
                alert("Successfully updated.");
            }
            else {
                alert("Some error occured while updating");
            }
            //   location.reload();
            that.fetchUserData();
        }, this.props.authData)
    }


    // for posting backend
    saveHandle(e) {
        e.preventDefault();  // Prevent form submission
        let paramArray = {};
        let errorMessages = [];  // Store error messages
        let checkValidity = true;  // Overall form validity
    
        if (this.state.updatedUsers !== null) {
            this.handleUserUpdate(this.state.updatedUsers);
        }
    
        let form_array = jQuery("#add_form").serializeArray();
    
        form_array.forEach(function (innerData) {
            let value = innerData.value.trim();  // Trim whitespace
    
            // Validation for first name and last name (check for special characters)
            if (innerData.name === 'firstName' || innerData.name === 'lastName') {
                if (checkSpecialChars(value)) {
                    checkValidity = false;
                    errorMessages.push(`${innerData.name === 'firstName' ? 'First Name' : 'Last Name'} contains invalid characters.`);
                }
            }
    
            // Validation for phone number (ensure 10 digits)
            else if (innerData.name === 'phone') {
                if (!/^[0-9]{10}$/.test(value)) {
                    checkValidity = false;
                    errorMessages.push('Phone number must be exactly 10 digits.');
                }
            }
    
            // Validation for password (custom logic for special characters in password)
            else if (innerData.name === 'password') {
                if (!checkSpecialChars(value, 'password')) {
                    checkValidity = false;
                    errorMessages.push('Password Requirements:\n1. Must contain at least 1 uppercase letter.\n2. Must contain at least 1 lowercase letter.\n3. Must contain at least 1 numeric character.\n4. Must be 8 characters or longer.');
                }
            }
    
            // Validation for email (using regex)
            else if (innerData.name === 'email') {
                // Updated regex to ensure proper domain and TLD structure
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                const validTlds = [
                    'com', 'net', 'org', 'edu', 'gov', 'mil', 'int', // Common TLDs
                    'uk', 'us', 'ca', 'de', 'fr', 'jp', 'au', 'in',
                ];
                const emailParts = value.split('@');
                const domainParts = emailParts[1] ? emailParts[1].split('.') : [];
                const tld = domainParts[domainParts.length - 1].toLowerCase();

                // Check if the email matches the regex and the domain contains at least one dot
                if (!emailRegex.test(value) || domainParts.length < 2 || domainParts.some(part => part === ''|| !validTlds.includes(tld) )) {
                    checkValidity = false;
                    errorMessages.push('Invalid email address. Ensure it follows the correct format (e.g., user@example.com).');
                }
            }
    
            // If valid, sanitize and add to paramArray
            if (checkValidity) {
                paramArray[innerData.name] = sanitizeHtml(value);
            }
        });       
    
        // If any validation errors were found, display all error messages
        if (errorMessages.length > 0) {
            alert(errorMessages.join('\n'));
            return;  // Stop form submission
        }
    
        // If all fields are valid, proceed with API call
        let user_array = this.state.users;
        paramArray['label'] = `${paramArray.firstName} ${paramArray.lastName}`;
        paramArray['primaryEmail'] = paramArray['email'];
        paramArray['createdBy'] = paramArray[''];
        paramArray['status'] = "Active";
        paramArray['isSuspended'] = "0";
        paramArray['isDeleted'] = "0";
        paramArray['rockmetric_update'] = true;
        paramArray['rockmetric_new_entry'] = true;
        paramArray['activatedMail'] = 0;
    
        user_array.unshift(paramArray);
    
        this.setState({ users: user_array });
    
        jQuery("#addContent").modal('toggle');  // Close modal after successful save
        jQuery("#addContent").trigger("reset");  // Reset form
    }
    
    

    text_to_json(data) {
        let that = this;
        csv({
            output: "json",
            noheader: false,
            headers: Object.keys(this.headerMapping),
            // nullObject:true,
            colParser: {
                "metricPrefix": function (item, head, resultRow, row, colIdx) {
                    let metricType = that.getJSON(Object.values(that.state[head]));
                    return metricType[item] ? metricType[item] : null;
                },
                "metricUnit": function (item, head, resultRow, row, colIdx) {
                    let unit = that.getJSON(Object.values(that.state[head]));
                    return unit[item] ? unit[item] : null;
                },
                "numberShorten": function (item, head, resultRow, row, colIdx) {
                    let shorten = that.getJSON(Object.values(that.state[head]));
                    return shorten[item] ? shorten[item] : null;
                },
                "roundOff": function (item, head, resultRow, row, colIdx) {
                    let roundOff = that.getJSON(Object.values(that.state[head]));
                    return roundOff[item] ? roundOff[item] : null;
                }
            }
        }).fromString(data)
            .then(function (result) {
                let metric = that.state.metric;

                metric.metric = [...result, ...metric.metric];
                that.setState({
                    metric: metric
                });
                jQuery("#importKPI").modal('hide');
                that.handleButton(null, 1);
            })
    }


    change_table_format(array_data) {
        try {
            var that = this;
            let temp_array = [];
            if (array_data != null) {
                array_data.forEach(innerData => {
                    let inner_temp_object = {};

                    if (innerData.firstName && innerData.lastName) {
                        inner_temp_object.label = `${innerData.firstName.charAt(0).toUpperCase() + innerData.firstName.slice(1)} ${innerData.lastName.charAt(0).toUpperCase() + innerData.lastName.slice(1)}`;
                    } else if ((innerData.firstName === null || innerData.firstName === "") && innerData.lastName) {
                        inner_temp_object.label = `${innerData.lastName.charAt(0).toUpperCase() + innerData.lastName.slice(1)}`;
                    } else if ((innerData.lastName === null || innerData.lastName === "") && innerData.firstName) {
                        inner_temp_object.label = `${innerData.firstName.charAt(0).toUpperCase() + innerData.firstName.slice(1)}`;
                    }

                    if (innerData.primaryEmail !== null && innerData.primaryEmail !== undefined) {
                        inner_temp_object.email = innerData.primaryEmail ? innerData.primaryEmail : null;
                    }

                    if (innerData.userId !== null && innerData.userId !== undefined) {
                        inner_temp_object.userId = innerData.userId;
                    };

                    if (innerData.registerTime !== null && innerData.registerTime !== undefined) {
                        inner_temp_object.createdBy = innerData.registerTime;
                    }

                    if (innerData.isDeleted == "0" && innerData.isSuspended == "0") {
                        inner_temp_object.status = "Active";
                    } else if (innerData.isSuspended == "1") {
                        inner_temp_object.status = "Suspended";
                    }

                    if (innerData.activatedMail === null || innerData.activatedMail === undefined) {
                        inner_temp_object.activatedMail = that.state.activatedMail[0].name;
                    } else inner_temp_object.activatedMail = that.state.activatedMail[innerData.activatedMail].name; ``

                    if (innerData.isDeleted !== "1") {
                        temp_array.push(inner_temp_object);
                    }
                });

                return { data: temp_array }
            }
            else {
                return { data: { data: [] } }
            }
        } catch (e) {
            return "error";
        }
    }

    handleDataUpdate(data) {

        // function returnUpdatedValue(data){
        //     if(data['rockmetric_update']== true){
        //         return data;}
        // }
        // let toupdatedata=data.filter(returnUpdatedValue); 
        var userStatus = jQuery('#userStatus_form_data').val();

        for (var j = 0; j < data.length; j++) {
            if (data[j]['rockmetric_update'] == true) {
                if (userStatus == '0') {
                    data[j]['isSuspended'] = "0";
                    data[j]['isDeleted'] = "0";
                } else if (userStatus == '1') {
                    data[j]['isSuspended'] = "1";
                    data[j]['isDeleted'] = "0";
                } else if (userStatus == '3') {
                    data[j]['isSuspended'] = "0";
                    data[j]['isDeleted'] = "1";
                }
            }
        }


        let columns = this.state.users;
        columns = data;
        this.setState({
            users: columns
        });
    }
    userAccessTable() {
        let rowselecteduser = null;
        let rowselecteduserfromtable = gridOptions.api.getSelectedNodes()[0]['data']['email'];
        for (var i = 0; i < this.state.users.length; i++) {
            if (this.state.users[i]['primaryEmail'] == rowselecteduserfromtable) {
                rowselecteduser = this.state.users[i];
            }
        }
        if (rowselecteduser) { }
        // this.setState({selecteduser:rowselecteduser})
        this.props.history.push({
            pathname: '/admin/useraccess',
            // search: '?query=abc',
            state: { data: rowselecteduser, datasetValue: this.props.datasetValue }
        })
        //  jQuery('#updateModal').modal('show');
    }

    restrictMenuOption(params, actionArray) {
        let disabledFlag;
        if (actionArray.name == "permissions" && params.data.status == "Suspended") {
            disabledFlag = true
        }

        return disabledFlag;

    }

    handleUserAccess(e) {
        if (e !== null && e !== undefined) {

        }
        else {

            // jQuery("#updateModal").show();
            jQuery('#updateModal').modal('show');

            //###########UPDATEEEE MODALLL###########
            // var accessFormBody = <Form label_array={accessFormData} call_back={this.call_back_form} />;

            // var accessModalArray = { 
            //     "addModal": {
            //         "form_name": "access_form", "title": "Edit User Access ", "body": accessFormBody, "button_name": "Update", "action":"add", "display":true
            //         }
            //      };


            // return (<ModalComponent modalConfig={accessModalArray} action={this.handleUserAccess} />)


        }
    }

    resetUserPassword(e) {
        let selectedUser = gridOptions.api.getSelectedNodes(), checkValidity = true;
        if (selectedUser.length > 1) {
            alert('Please select only one user for password reset!');
            jQuery("#passwordModal").modal('toggle');

        }
        else if (e !== null && e !== undefined && (selectedUser.length = 1)) {
            let passwordFormArray = jQuery("#resetForm").serializeArray();
            if (passwordFormArray[0]['value'] == '' || passwordFormArray[1]['value'] == '') {
                alert('Password fields cannot be empty!');
            }
            else if (passwordFormArray[0]['value'] !== passwordFormArray[1]['value']) {
                alert('Passwords do not match!');
            }
            else if (passwordFormArray[0]['value'] == passwordFormArray[1]['value']) {
                checkValidity = checkValidity ? (checkSpecialChars(passwordFormArray[0]['value'], 'password') ? true : false) : false
                checkValidity = checkValidity ? (checkSpecialChars(passwordFormArray[1]['value'], 'password') ? true : false) : false
                if (checkValidity === false) {
                    alert('Password Requirements:\n1. Must contain at least 1 uppercase alphabet.\n2. Must contain at least 1 lowercase alphabet.\n3. Must contain at least 1 numeric character.\n4. Must be 8 characters or longer.')
                } else {
                    let params = {
                        siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                        companyName: this.props.authData.companyName
                    }
                    let data = {
                        newPassword: passwordFormArray[0]['value'],
                        selectedUserId: selectedUser[0]['data']['userId'],
                        userId: this.props.authData.userId
                    }
                    CallAPI('POST', "/app/userConfig/updateUserPassword", data, params, null, function (response) {
                        alert('Password Reset Successfully!');
                        jQuery("#passwordModal").modal('toggle');
                    }, this.props.authData)
                }
            }
        }
        else {
            jQuery("#passwordModal").modal('toggle');
        }
    }

    paginate = (pageNumber) => {
        this.setState({ ...this.state, currentPage: pageNumber })
        this.fetchUserData(pageNumber)
    }
    nextPagePaginate = (pageNumber) => {
        let newPage = pageNumber + 1
        this.setState({ ...this.state, currentPage: newPage })
        this.fetchUserData(newPage)
    }
    previousPagePaginate = (pageNumber) => {
        let newPage = pageNumber - 1
        this.setState({ ...this.state, currentPage: newPage })
        this.fetchUserData(newPage)
    }

    render() {
        var mainData;
        let final_data = this.change_table_format(this.state.users ? this.state.users : null);

        if (final_data !== "error") {
            let userStatus = Object.values(this.state.userStatus).map(function (value) {
                return value.name;
            });

            let emailAccessValues = Object.values(this.state.activatedMail).map((element, i) => {
                return element.name;
            });

            let accessForm = {
                // "accessFilters": {
                //     "name": "accessFilters", "label": "Row Level Access", "type": "dropdown","multiple":true,"options":[
                //         { "name": "Select Option", "value": null },...Object.values(this.state.property)     
                //     ]
                // },
                "accessRights": {
                    "name": "accessRights", "label": "Access Rights", "type": "dropdown", "options": [
                        // Don't change option needed
                        { "name": "Read Only", "value": "3" },
                        // { "name": "Select Option", "value": "2" },

                        { "name": "No Access", "value": "0", },

                        { "name": "Admin", "value": "1" },
                    ]
                }
            }
            var columns_array = [
                { label: "Status", value: "status", type: "html", dropdown_value: userStatus, editable: true, hide: false, dataType: 'string' },
                { label: "Email", value: "email", type: "text", editable: false, dataType: 'string', hide: false },
                { label: "Email Access", type: "html", value: "activatedMail", dropdown_value: emailAccessValues, editable: true, hide: false, dataType: 'string' },
                { label: "Created Date", value: "createdBy", type: "text", editable: false, hide: false, dataType: 'string' },
                // { label: "Unit", value: "metricUnit", type: "html", dropdow,editabln_value: metricUnit, editable: true }
            ];

            var firstColumn = "Name";

            var passwordformData = {
                "userPassword": { "name": "userPassword", "label": "Password", "type": "password", 'eyeIcon': true },
                "confirmPassword": { "name": "confirmPassword", "label": " Confirm Password", "type": "password", 'eyeIcon': true },
            }
            
         var searchInput = {
            "searchInput": { "form_name": "searchInput", "type": "customSearch", "requiredFlag": true ,'placeholder':"Search by User",'text_value':this.state.searchValue},
        }

            var Add_Form_Data = <Form label_array={this.formData} call_back={this.call_back_form} />;
            var search_Input = <Form label_array={searchInput} onSearch={this.searchUser} call_back={this.call_back_form} type="customSearch" />
            var Bulk_Form_Data = <Form label_array={this.bulkFormData} call_back={this.call_back_form} />;
            var import_Form_Data = <Form label_array={this.importFormData} call_back={this.call_back_form} />;
            var access_Form_Data = <Form label_array={accessForm} call_back={this.call_back_form} />;
            var password_Form_Data = <Form label_array={passwordformData} call_back={this.call_back_form} />;
            // var userAccessTable = <UserAccessComponent data={this.state.selecteduser} datasetValue={`this.props.datasetValue`}/>


            var modals = {
                "addModal": {
                    "form_name": "add_form", "title": "Add User", "body": Add_Form_Data, "button_name": "Add", "action": "add", "buttonType": "submit", "display": true
                },
                "bulkModal": {
                    "form_name": "bulk_form", "title": "Edit User", "body": Bulk_Form_Data, "button_name": "Update", "action": "bulk", "display": true
                },
                "importModal": {
                    "form_name": "import_form", "title": "Import Metric Format", "body": import_Form_Data, "button_name": "Import", "action": "import", "display": true
                },
                "updateModal": {
                    "form_name": "access_form", "title": "Edit User Permissions ", "body": access_Form_Data, "button_name": "Update", "action": "update", "display": true
                },
                "passwordModal": {
                    "form_name": "password_form", "form_id": "resetForm", "id": "passwordModal", "title": "Reset Password ", "body": password_Form_Data, "button_name": "Reset", "display": true,
                }
            };

            var appendMenu = {
                "permissions": {
                    "name": "permissions", "label": "Manage Permissions", "action": this.userAccessTable,
                },
                "resetPassword": {
                    "name": "resetPassword", "label": "Reset Password", "action": this.resetUserPassword
                }
            }
       
            var topSearchBarDiv = (<div className="search-form mg-r-10">
                {search_Input}</div>
            )
                if (this.props.location.state?.data)
                    var extraInfo = (
                        <>
                            {/* <div class="input-group mg-r-10"> */}
                            <div className="btn btn-outline-light mg-l-5 float-right tx-medium tx-12 tx-sans btn-outline-light">Selected Report: {this.props.location.state.data.reportName}	</div>
                            <div class="input-group-append "  >
                                <span class="input-group-text"><i className='fas fa-window-close mg-t-2' id='remove' onClick={(e) => this.fetchUserData(null, 'remove', '',true)} aria-hidden="true" style={{ cursor: 'pointer' }}></i></span>
                            </div>
                            {/* </div> */}
                        </>
                    )
            

            mainData = (<>
                <TableParent
                    data={final_data}
                    parentConfig={this.state}
                    noRowsAvailable={this.state.totalPages}
                    columns_array={columns_array}
                    firstColumn={firstColumn}
                    editData={this.state.users}
                    modalConfig={modals}
                    onCellChange={this.change_handle}
                    filename="User List"
                    // actionArray={this.props.menuData}
                    menuAction={this.handleMenuAction}
                    handleDataUpdate={this.handleDataUpdate}
                    saveHandle={this.saveHandle}
                    pagination={false}
                    restrictOption={this.restrictMenuOption}
                    buttonConfig={this.buttons}
                    submitHandle={this.submitHandle}
                    // submitHandle={this.saveHandle}
                    rowSelection="multiple"
                    customMenu={appendMenu}
                    updateModalAction={this.handleUserAccess}
                    topSearchBar={false}
                    topSearchBarDiv={topSearchBarDiv}
                    selectedReport={extraInfo?extraInfo:null}
                    noFilters={false}
                    topDivStyle='mg-t-15'
                />
                <div className="d-flex row justify-content-center p-2">
                    <Pagination
                        currentPage={this.state.currentPage}
                        totalPages={this.state.totalPages}
                        paginate={this.paginate}
                        nextPagePaginate={this.nextPagePaginate}
                        previousPagePaginate={this.previousPagePaginate}
                    />
                </div>
                <ModalComponent modalConfig={modals["passwordModal"]} action={this.resetUserPassword} />
            </>);
        } else {
            mainData = <ErrorComponent />;
        }
        // }

        return (
            <div>
                {/* <DatasetFilter /> */}
                {mainData}
            </div>
        );
    }
}

export default UserComponent;